export const pad = (n: number) => String(n).padStart(2, "0");
export const toYMD = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const formatDate = (date: string | Date, shortDate?: boolean) => {
  if (!date) return "";
  
  let dateObj: Date;
  
  // Se já for um objeto Date, usar diretamente
  if (date instanceof Date) {
    dateObj = date;
  } 
  // Se for string ISO (formato: 2025-08-04T14:04:12.468Z)
  else if (typeof date === 'string' && date.includes('T')) {
    dateObj = new Date(date);
  }
  // Se for string no formato antigo (YYYY-MM-DD), manter lógica existente
  else if (typeof date === 'string') {
    dateObj = new Date(
      `${date.replace(/-/g, "/")} 12:00:00`
    );
  }
  else {
    return "";
  }
  
  // Validar se a data é válida
  if (isNaN(dateObj.getTime())) {
    return "";
  }
  
  if (shortDate) {
    return dateObj.toLocaleDateString("pt-BR", {
      timeZone: "America/Sao_Paulo",
      day: "2-digit",
      month: "2-digit",
    });
  }
  
  return dateObj.toLocaleDateString("pt-BR", {
    timeZone: "America/Sao_Paulo",
  });
};

export function formatTextDate(dateStr) {
  let [day, month, year] = dateStr.split('/');
  let formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export function formatDateText(dateStr) {
  if (!dateStr) return "";
  let [year, month, day] = dateStr.split('-');
  let formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}

export function addMonths (dateStr: string, months: number) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  date.setMonth(date.getMonth() + months);
  return toYMD(date);
};

export function getEndDateMax (today, startDate?: string | null) {
  if (!startDate) return today;
  const max3Months = addMonths(startDate, 3);
  return max3Months < today ? max3Months : today;
};